export default __webpack_public_path__ + "static/media/Workers-Compensation-Template.c439df9e.csv";